import { render, staticRenderFns } from "./profileExercises.vue?vue&type=template&id=44d6f29d&"
import script from "./profileExercises.vue?vue&type=script&lang=js&"
export * from "./profileExercises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports